import {useInfiniteQuery} from '@tanstack/react-query';
import { validate as isValidUUID } from 'uuid';

import api from 'services/api';

const usePipelines = ({filters, datasetId}) => {

    const fetchPipelineRuns = async ({pageParam = 1}) => {
        const query = new URLSearchParams({
            page: pageParam
        });

        if (datasetId) {
            query.append('dataset', datasetId);
        }

        if (filters.status) {
            query.append('status', filters.status);
        }

        if (filters.type) {
            query.append('type', filters.type);
        }

        if (filters.pipeline_run_id) {
            // Only allow if it's empty or a valid UUID
            if (filters.pipeline_run_id === '' || isValidUUID(filters.pipeline_run_id)) {
                query.append('pipeline_run_id', filters.pipeline_run_id);
            }

        }
        if (filters.experiment_id) {
            // Only allow if it's empty or a valid UUID
            if (filters.experiment_id === '' || isValidUUID(filters.experiment_id)) {
                query.append('experiment_id', filters.experiment_id);
            }
        }

        if (filters.pipelineName) {
            query.append('pipeline_name', filters.pipelineName);
        }


        try {
            const results = await api.get(`api/v1/pipelines/runs?${query.toString()}`);
            const {
                data: {
                    payload: {pipeline_runs},
                    meta,
                },
            } = await results.json();

            return {data: pipeline_runs, meta};
        } catch (e) {
            return Promise.reject(e);
        }
    };

    return useInfiniteQuery(['pipeline-runs-v1', datasetId, filters], fetchPipelineRuns, {
        refetchOnWindowFocus: false,
        cacheTime: 0,
        getNextPageParam: ({meta: {next_page}}, allPages) => {
            if (next_page === 0) return undefined;

            return next_page;
        },
    });
};

export default usePipelines;
